/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Optional_EarliestInputs */

const en_consumer_declaration_optional_earliest = /** @type {(inputs: Consumer_Declaration_Optional_EarliestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional; leave blank for the earliest possible date.`)
};

const de_consumer_declaration_optional_earliest = /** @type {(inputs: Consumer_Declaration_Optional_EarliestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional; leer lassen für den frühestmöglichen Zeitpunkt.`)
};

const fr_consumer_declaration_optional_earliest = /** @type {(inputs: Consumer_Declaration_Optional_EarliestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facultatif ; laissez vide pour la première date possible.`)
};

const es_consumer_declaration_optional_earliest = /** @type {(inputs: Consumer_Declaration_Optional_EarliestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcional; déjalo vacío para la primera fecha posible.`)
};

const it_consumer_declaration_optional_earliest = /** @type {(inputs: Consumer_Declaration_Optional_EarliestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facoltativo; lascia vuoto per la prima data possibile.`)
};

const nl_consumer_declaration_optional_earliest = /** @type {(inputs: Consumer_Declaration_Optional_EarliestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optioneel; laat leeg voor de vroegst mogelijke datum.`)
};

const pl_consumer_declaration_optional_earliest = /** @type {(inputs: Consumer_Declaration_Optional_EarliestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcjonalne; pozostaw puste dla najwcześniejszego terminu.`)
};

const fi_consumer_declaration_optional_earliest = /** @type {(inputs: Consumer_Declaration_Optional_EarliestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valinnainen; jätä tyhjäksi aikaisinta mahdollista päivää varten.`)
};

const da_consumer_declaration_optional_earliest = /** @type {(inputs: Consumer_Declaration_Optional_EarliestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valgfrit; lad feltet være tomt for tidligst mulige dato.`)
};

const sv_consumer_declaration_optional_earliest = /** @type {(inputs: Consumer_Declaration_Optional_EarliestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valfritt; lämna tomt för tidigast möjliga datum.`)
};

/**
* | output |
* | --- |
* | "Optional; leave blank for the earliest possible date." |
*
* @param {Consumer_Declaration_Optional_EarliestInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_optional_earliest = /** @type {((inputs?: Consumer_Declaration_Optional_EarliestInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Optional_EarliestInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_optional_earliest(inputs)
	if (locale === "fr") return fr_consumer_declaration_optional_earliest(inputs)
	if (locale === "es") return es_consumer_declaration_optional_earliest(inputs)
	if (locale === "it") return it_consumer_declaration_optional_earliest(inputs)
	if (locale === "nl") return nl_consumer_declaration_optional_earliest(inputs)
	if (locale === "pl") return pl_consumer_declaration_optional_earliest(inputs)
	if (locale === "fi") return fi_consumer_declaration_optional_earliest(inputs)
	if (locale === "da") return da_consumer_declaration_optional_earliest(inputs)
	if (locale === "sv") return sv_consumer_declaration_optional_earliest(inputs)
	return en_consumer_declaration_optional_earliest(inputs)
});